import { createStore, applyMiddleware } from 'redux';
import reducers from './reducers/reducers';
import middlewares from './middlewares/middlewares';
import { updateTheme } from './middlewares/themes.middleware.js';
import { persistedState, saveState } from './persisted.store.js';

const store = createStore(
  reducers,
  persistedState, // second argument overrides the initial state
  applyMiddleware(...middlewares)
);

// Debounce persistence — never sync-write on every dispatch.
let persistTimer = null;
store.subscribe(() => {
  if (persistTimer) clearTimeout(persistTimer);
  persistTimer = setTimeout(() => {
    saveState(store.getState());
  }, 500);
});

// Update the initial theme
updateTheme(store.getState());

window.store = store;
export { store };
